// extracted by mini-css-extract-plugin
var _1 = "appContent-C_IQ";
var _2 = "appView-TBv6";
export { _1 as "appContent", _2 as "appView" }
